import { z } from 'zod';

// CSP が eval を許さないため、Zod が new Function を試して違反レポートを出すのを止める (#3678)
z.config({ jitless: true });
